var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-media-gallery',{attrs:{"attachment":_vm.message.attachment,"price":_vm.price,"is-author":_vm.isAuthor,"is-available":_vm.available,"blocking-status":_vm.blockingStatus},on:{"unlock":_vm.onUnlock}})}
var staticRenderFns = []

export { render, staticRenderFns }